import React from 'react';
import Modal from './Modal';
import Button from './Button';

/**
 * A reusable confirmation dialog with a premium look matching the uploaded reference.
 */
const ConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    type = 'warning', // 'warning', 'error', 'info', 'success'
    confirmText = 'Tamam',
    cancelText = 'İptal',
    showCancel = true
}) => {
    const getIcon = () => {
        switch (type) {
            case 'error': return '❌';
            case 'info': return 'ℹ️';
            case 'success': return '✅';
            default: return '⚠️';
        }
    };

    const getGlowColor = () => {
        switch (type) {
            case 'error': return 'rgba(239, 68, 68, 0.4)';
            case 'info': return 'rgba(59, 130, 246, 0.4)';
            case 'success': return 'rgba(34, 197, 94, 0.4)';
            default: return 'rgba(234, 179, 8, 0.4)'; // Warning (Yellow/Gold)
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="sm"
            shadowColor={getGlowColor()}
        >
            <div className="flex flex-col items-center text-center p-lg py-xl">
                {/* Header Icon & Title */}
                <div className="flex items-center gap-md mb-xl w-full justify-start pl-md">
                    <span style={{ fontSize: '24px' }}>{getIcon()}</span>
                    <h2 style={{ fontSize: '20px', fontWeight: '800', margin: 0, color: 'white' }}>{title}</h2>
                </div>

                {/* Big Central Illustration Icon */}
                <div
                    style={{
                        fontSize: '80px',
                        marginBottom: '32px',
                        filter: `drop-shadow(0 0 20px ${getGlowColor()})`,
                        animation: 'pulse 2s infinite ease-in-out'
                    }}
                >
                    {getIcon()}
                </div>

                {/* Message */}
                <div
                    className="mb-xl px-lg"
                    style={{
                        color: 'rgba(255,255,255,0.8)',
                        fontSize: '16px',
                        lineHeight: '1.6',
                        fontWeight: '500'
                    }}
                >
                    {message}
                </div>

                {/* Actions */}
                <div className="flex gap-md w-full mt-md pt-lg" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
                    {showCancel && (
                        <Button
                            variant="secondary"
                            onClick={onClose}
                            style={{ flex: 1, padding: '12px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
                        >
                            {cancelText}
                        </Button>
                    )}
                    <Button
                        variant={type === 'error' ? 'danger' : 'primary'}
                        onClick={onConfirm}
                        style={{ flex: 1, padding: '12px' }}
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>

            <style>{`
                @keyframes pulse {
                    0% { transform: scale(1); opacity: 0.8; }
                    50% { transform: scale(1.05); opacity: 1; }
                    100% { transform: scale(1); opacity: 0.8; }
                }
            `}</style>
        </Modal>
    );
};

export default ConfirmDialog;
